var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("QuotationCenter.components.excelImportMethod"),
        visible: _vm.dialogVisible,
        width: "520px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.resetImportDialog,
      },
    },
    [
      _c(
        "el-form",
        {
          staticClass: "import-dialog-form",
          attrs: { "label-position": "top" },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("QuotationCenter.components.clickUpload"),
              },
            },
            [
              _c(
                "el-upload",
                {
                  ref: "importUpload",
                  staticClass: "import-upload",
                  attrs: {
                    drag: "",
                    action: "",
                    accept: ".xls,.xlsx",
                    limit: 1,
                    "file-list": _vm.importFileList,
                    "auto-upload": false,
                    "on-change": _vm.handleImportFileChange,
                    "on-exceed": _vm.handleImportFileExceed,
                    "on-remove": _vm.handleImportFileRemove,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v(
                      _vm._s(_vm.$t("QuotationCenter.components.clickUpload"))
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("QuotationCenter.components.onlySupportExcel")
                        )
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("fileSearch.table.FileType") } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.importForm.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.importForm, "type", $$v)
                    },
                    expression: "importForm.type",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v("Supports Incremental, Direct Mu"),
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v("FirstAdditional Weight"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("cancelText")))]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", loading: _vm.loading },
              on: { click: _vm.confirmImport },
            },
            [_vm._v(_vm._s(_vm.$t("toast.okText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }